export default (state = true, action = {}) => {
  switch (action.type) {
    case 'LINK_COPIER_TOGGLE':
      return action.shouldShow;
    default:
      return state;
  }
};
